import { useTheme } from './ThemeProvider';

export function ThemeToggle() {
  const { mode, toggle } = useTheme();

  return (
    <button
      onClick={toggle}
      aria-label={`Switch to ${mode === 'light' ? 'dark' : 'light'} mode`}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '6px 14px',
        background: 'var(--bg-tertiary)',
        border: '1px solid var(--border-medium)',
        borderRadius: '20px',
        color: 'var(--text-secondary)',
        fontSize: '14px',
        fontWeight: 500,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        userSelect: 'none',
      }}
      onMouseEnter={e => {
        (e.currentTarget as HTMLButtonElement).style.borderColor = 'var(--accent-primary)';
        (e.currentTarget as HTMLButtonElement).style.color = 'var(--accent-primary)';
      }}
      onMouseLeave={e => {
        (e.currentTarget as HTMLButtonElement).style.borderColor = 'var(--border-medium)';
        (e.currentTarget as HTMLButtonElement).style.color = 'var(--text-secondary)';
      }}
    >
      <span style={{ fontSize: '16px' }}>{mode === 'light' ? '☀️' : '🌙'}</span>
      <span>{mode === 'light' ? 'Light' : 'Dark'}</span>
    </button>
  );
}
